import { MeetingEntitiesOverview, MeetingEntity, MeetingEntityTemplateItem } from './meeting-entities.service'

export type MeetingEntityReadiness = 'NO_MEETING_MINUTES' | 'NO_INTERVALS' | 'NO_ENTITY_SPECIFIC_ITEMS' | 'READY'

/** Whether an item's minutes are its own entity's, because it or an item above it is minuted per entity. */
export function inheritsEntityScope(item: MeetingEntityTemplateItem, items: MeetingEntityTemplateItem[]): boolean {
  const parent = item.parentId === null ? null : (items.find((candidate) => candidate.templateItemId === item.parentId) ?? null)
  return parent !== null && (parent.isEntitySpecific || inheritsEntityScope(parent, items))
}

/** Mirrors the checks the server makes before it will generate an entity's minutes, in the order it makes them. */
export function resolveMeetingEntityReadiness(overview: MeetingEntitiesOverview, entity: MeetingEntity): MeetingEntityReadiness {
  if (!overview.hasMeetingMinutes) {
    return 'NO_MEETING_MINUTES'
  }
  if (entity.intervals.length === 0) {
    return 'NO_INTERVALS'
  }
  const appliesToEntity = overview.templateItems.some(
    (item) =>
      item.isEntitySpecific &&
      !inheritsEntityScope(item, overview.templateItems) &&
      (item.applicableMeetingEntityIds.length === 0 || item.applicableMeetingEntityIds.includes(entity.id))
  )
  return appliesToEntity ? 'READY' : 'NO_ENTITY_SPECIFIC_ITEMS'
}
